/* eslint-disable import/prefer-default-export */
import * as yup from "yup";

export const retailerId = yup.string().uuid().required().label("Retailer");

export const name = yup
  .string()
  .transform((v: string | null) => v || null)
  .min(2)
  .trim()
  .nullable()
  .label("Name");

export const storeNumber = yup
  .number()
  .label("Store #")
  .nullable()
  .defined()
  .default(null)
  .min(1)
  .max(2147483647);

export const region = yup.string().trim().nullable().label("Region");

export const notes = yup.string().trim().nullable().label("Notes");

export const isArchived = yup.bool().default(false).defined().label("Archive?");

export const website = yup
  .string()
  .url("Please enter a valid URL")
  .nullable()
  .label("Website");

export const distributionCenterIds = yup
  .array()
  .of(yup.string().uuid().required())
  .ensure()
  .default([])
  .label("Distribution Centers");
